import * as React from 'react';
import {
  Dialog, DialogActions, DialogContent, DialogTitle,
  Slide, Typography, Box, Button
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { useColorScheme } from "@mui/material/styles";
import HelpCenterIcon from '@mui/icons-material/HelpCenter';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface SellerAlertProps {
  open: boolean;
  onClose: () => void;
  onCheckInResponse: (response: 'Recebe visita do representante periodicamente: sim' | 'Recebe visita do representante periodicamente: não') => void;
}

const SellerAlert = ({ open, onClose, onCheckInResponse }: SellerAlertProps) => {

  const scheme = useColorScheme();
  const isLightMode = scheme.mode === 'light';
  const contrastColor = isLightMode ? 'black' : 'white';
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            onClose();
          }
        }}
        disableEscapeKeyDown
        slots={{ transition: Transition }}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Pesquisa de satisfação"}</DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',

            }}
          >
            <HelpCenterIcon
              sx={{
                fontSize: 80,
                color: contrastColor,
                animation: 'scaleUp 0.5s ease-out'
              }}
            />
            <Typography sx={{ mt: 2, textAlign: 'center' }} variant="body1">
              Recebe visita do representante periodicamente?
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions sx={{ justifyContent: 'center', gap: 2 }}>
          <Button
            variant="contained"
            color="success"
            sx={{ color: "#fff" }}
            onClick={() => {
              onCheckInResponse('Recebe visita do representante periodicamente: sim');
              onClose();
            }}
          >
            Sim
          </Button>
          <Button
            variant="contained"
            color="error"
            sx={{ color: "#fff" }}
            onClick={() => {
              onCheckInResponse('Recebe visita do representante periodicamente: nao');
              onClose();
            }}
          >
            Não
          </Button>
        </DialogActions>
      </Dialog>

      <style>
        {`@keyframes scaleUp {
            0% { transform: scale(0); opacity: 0; }
            100% { transform: scale(1); opacity: 1; }
        }`}
      </style>
    </React.Fragment>
  );
};

export default SellerAlert;
